// Sorteia uma ignição sem repetir a última nem as já usadas.
// Quando todas forem usadas, reinicia o ciclo (mantendo só a última fora).
// Pool definido por você: 1 Explosão, 2 Giro+Luz, 3 Faísca, 9 Estouro, 10 Anel.

const POOL = [1, 2, 3, 9, 10];

let used = [];
let last = null;

export function pickIgnition() {
  let avail = POOL.filter((x) => !used.includes(x) && x !== last);

  if (avail.length === 0) {
    used = last != null ? [last] : [];
    avail = POOL.filter((x) => x !== last);
    if (avail.length === 0) avail = [...POOL];
  }

  const choice = avail[Math.floor(Math.random() * avail.length)];
  used.push(choice);
  last = choice;
  return choice;
}

export function resetIgnitionHistory() {
  used = [];
  last = null;
}

export { POOL as IGNITION_POOL };